export const splitEmailsString = (str: string) =>
	str
		.replace(/[\n\r]/g, '')
		.split(',')
		.filter(Boolean)
		.map((email) => email.trim());
